import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { FeedbackType } from '@/models/feedback.model';
import { FeedbacksListsState, FEEDBACKS_SLICE_NAME } from './models';

export const feedbacksSelector = (state: RootState): FeedbacksListsState => state[FEEDBACKS_SLICE_NAME];

export const selectQuery = createSelector(feedbacksSelector, (state: FeedbacksListsState) => state.query);

export const selectNewFeedbacksCount = createSelector(
  feedbacksSelector,
  (state: FeedbacksListsState) => state.newCount,
);

export const selectNewFeedbacksCountByType = createSelector(
  feedbacksSelector,
  (state: FeedbacksListsState) => state.newCountByType,
);

export const sumNewFeedbacksCountByTypes = (
  countsByType: Record<FeedbackType, number>,
  types: FeedbackType[],
): number => types.reduce((sum, type) => sum + (countsByType[type] ?? 0), 0);
